import React, { useEffect, useState } from 'react';
import { SupportRequest, getSupportRequests } from '../hooks/api-methods/useSupport';
import CustomDropdown from '../componentsNew/Dropdown';
import MyMasonry from '../componentsNew/Mansory/Mansory';
import SearchInput from '../componentsNew/Inputs/SearchInput';
import Loader from '../componentsNew/Loader/Loader';

const SupportManager: React.FC = () => {
  const [subscription, setSubscription] = useState<SupportRequest[]>([]);
  const [filteredSubject, setFilteredSubject] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const data = await getSupportRequests();
        setSubscription(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching templates:', err);
      }
    };

    fetchTemplates();
  }, []);

  const subjectOptions = ['all', ...Array.from(new Set(subscription.map((item) => item.subject)))];

  const filteredMessages = subscription.filter((msg) => {
    const matchesSubject = filteredSubject === 'all' || msg.subject === filteredSubject;
    const matchesName = msg.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSubject && matchesName;
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="flex-column gap-2 w-100">
      <h3>Manage Messages</h3>

      <div className="flex-row gap-2 space-between ptb-1">
        <SearchInput
          value={searchTerm}
          onChange={setSearchTerm}
          placeholder="Search by name..."
          width="300px"
        />

        <CustomDropdown
          options={subjectOptions}
          value={filteredSubject}
          onChange={(val) => setFilteredSubject(val)}
        />
      </div>

      <MyMasonry
        items={filteredMessages}
        renderItem={(sub: SupportRequest) => (
          <div className="card-mail card--shadow w-100 p-1">
            <h4>
              <strong>Subject:</strong> {sub.subject}
            </h4>
            <p>
              <strong>Name:</strong> {sub.name}
            </p>
            <p>
              <strong>Phone:</strong> {sub.phone}
            </p>
            <p>
              <strong>Email:</strong> {sub.email}
            </p>
            <p>
              <strong>Note:</strong> {sub.note}
            </p>
            <p>
              <strong>Conditions:</strong> {sub.conditions ? 'Yes' : 'No'}
            </p>

            <div className="flex-row justify-end">
              <a
                href={`mailto:${sub.email}?subject=${encodeURIComponent(
                  `RE: ${sub.subject}`,
                )}&body=${encodeURIComponent(
                  `Beste ${sub.name},\n\nBedankt voor uw bericht.\n\nMet vriendelijke groet,\nAlexandro Degezelle`,
                )}`}
                className="btn btn-small btn-second-color"
              >
                Reply
              </a>
            </div>
          </div>
        )}
      />

      {filteredMessages.length === 0 && <p className="w-100 vh-75">No messages found.</p>}
    </div>
  );
};

export default SupportManager;
